// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__PFFL3","buttonDrawerStyle":"Sidebar_buttonDrawerStyle__QbzJ+","drawer":"Sidebar_drawer__qaTzX","divider":"Sidebar_divider__41fMs","nav":"Sidebar_nav__EIbGN"};